(function () {
  angular
    .module("akitabox.ui.dialogs.document.thumbnailFit")
    .service("ThumbnailFitDialog", ThumbnailFitDialog);

  /* @ngInject */
  function ThumbnailFitDialog($q, $log, $mdDialog, $mdMedia) {
    var modal = {
      templateUrl:
        "app/core/ui/dialogs/document/thumbnail-fit/thumbnail-fit.dialog.html",
      controller: "ThumbnailFitDialogController",
      controllerAs: "dialog",
      bindToController: true,
      parent: angular.element(document.body),
      closeTo: angular.element(document.body),
      clickOutsideToClose: false,
      focusOnOpen: false,
    };

    // Enable fullscreen mode while on mobile
    if ($mdMedia("sm") || $mdMedia("xs")) {
      modal.fullscreen = true;
    }

    var service = {
      show: show,
    };

    return service;

    // ------------------------
    //   Public Functions
    // ------------------------

    /**
     * Show select document dialog. `options.locals.building` is required
     *
     * @param  {Object}  options                       Dialog options
     * @param  {Object}  options.locals                Dialog options
     * @param  {Object}  options.locals.building       A building model
     * @param  {Object}  options.locals.document       A document model
     *
     * @return  {Promise<Object|Error>}  Promise that resolves with the selected document
     */
    function show(options) {
      if (!options || !options.locals) {
        if (!options.locals.building) {
          $log.error("SelectDocumentDialog: no building local provided");
        } else if (!options.locals.document) {
          $log.error("SelectDocumentDialog: no document local provided");
        }
        return $q.reject("Sorry, we weren't able to complete your request.");
      }
      var dialogOptions = angular.extend({}, modal, options);
      return $mdDialog.show(dialogOptions);
    }
  }
})();
